import { ITableFilterItem } from '@components/common/UTable/UTable';
import { DatePickerProps } from 'antd';
import dayjs from 'dayjs';

import { OrganizationShort } from '@/api/organizations/types';

export const filterSchema = (organizations?: OrganizationShort[]): ITableFilterItem[] => [
  {
    label: 'Дата наряда',
    placeholder: 'От',
    key: 'taskDate',
    type: 'date',
    payload: {
      disabledDate: (current: DatePickerProps['value']) => {
        return current && current > dayjs().endOf('day');
      },
      // defaultValue: dayjs(),
    },
  },
  {
    label: 'Период',
    key: 'executedAtDate',
    type: 'dateRange',
    payload: {
      disabledDate: (current: DatePickerProps['value']) => {
        return current && current > dayjs().endOf('day');
      },
      // defaultValue: [dayjs(), dayjs()],
    },
  },
  {
    label: 'Хозяйство',
    placeholder: 'Выберите хозяйство',
    key: 'organizationId',
    type: 'select',
    payload: {
      options: organizations?.map((value) => ({
        label: value.shortName,
        value: value.id,
      })),
    },
  },
];
